export default "__VITE_ASSET__CwVFGgxd__"